<template>
  <DragDialog
    title="转换队列"
    :width="1300"
    :visible.sync="visible"
    :footerBtn="[]"
    :cancel="closeDialog">
    <div class="common-table-box">
      <el-table
        highlight-selection-row
        class="publish-small-table publish-table"
        height="100%"
        :data="queueList"
        v-loading="tableLoading"
        ref="table"
        :header-row-class-name="customHeader">
        <el-table-column
          label="序号"
          type="index"
          width="75" />
        <el-table-column
          prop="zoneId"
          label="转换节点" />
        <el-table-column label="队列名称">
          <template v-slot="{ row }">
            <span>{{ row.queueName ? row.queueName : '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="用户名称">
          <template v-slot="{ row }">
            <span v-if="$theme.get().value !== 'dark'">{{ row.phoneNum ? row.phoneNum : '--' }}</span>
            <span v-else>{{ row.userName ? row.userName : '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="文件名称"
          width="240">
          <template v-slot="{ row }">
            <span
              class="text-overflow"
              :title="row.dataSetName">
              {{ row.dataSetName }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          label="文件大小"
          width="100">
          <template v-slot="{ row }">
            <span class="text-overflow">
              {{
                `${formatFileSize(row.fileTotalSize).fileSize}${
                  formatFileSize(row.fileTotalSize).unit
                }`
              }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          label="请求时间"
          width="180">
          <template v-slot="{ row }">
            <span v-if="row.convertStatus === 1">--</span>
            <span v-if="row.convertStatus === 2">{{ row.startTime }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="转换状态"
          width="200">
          <template v-slot="{ row }">
            <span v-if="row.convertStatus === 1">排队中</span>
            <span v-if="row.convertStatus === 5">停止中</span>
            <span v-if="row.convertStatus === 2 && !row.owned">转换中</span>
            <div
              v-if="row.convertStatus === 2 && row.owned"
              class="common-progress-box">
              <el-progress
                :show-text="false"
                :percentage="row.ratio ? row.ratio : 0">
              </el-progress>
              <div class="custom-text">
                <div class="text">{{ `${row.ratio ? row.ratio : 0}%` }}</div>
                <div class="progress-name-box text-overflow">
                  {{ row.rateMsg ? row.rateMsg : '' }}
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="100">
          <template v-slot="{ row }">
            <div class="common-button-box operation-cell">
              <el-button
                type="text"
                size="small"
                :disabled="
                  row.convertStatus === 2 ||
                  row.convertStatus === 5 ||
                  !row.owned
                "
                @click="moveQueue(row, true)"
                >上移</el-button
              >
              <el-button
                type="text"
                size="small"
                :disabled="
                  row.convertStatus === 2 ||
                  row.convertStatus === 5 ||
                  !row.owned
                "
                @click="moveQueue(row, false)"
                >下移</el-button
              >
            </div>
          </template>
        </el-table-column>
        <template slot="empty">
          <div class="common-empty-box">
            <bj-empty
              :image="require('@/assets/img/no-data.png')"
              class="empty-page">
              <template slot="description">
                <div class="empty-text">抱歉，没有找到相关内容</div>
              </template>
            </bj-empty>
          </div>
        </template>
      </el-table>
    </div>
  </DragDialog>
</template>

<script>
import DragDialog from '@/components/CustomDragDialog.vue'

import { Store } from '@/utils/store'

import {
  publicElemQueueService,
  privateElemQueueService,
  moveClPublicConvertQueue,
  moveClPrivateConvertQueue,
  getElemConvertStatus,
  getElemsConvertingProgress
} from '@/service/interface'

import { formatFileSize } from '@/utils/generalMethods'
export default {
  data() {
    return {
      tableLoading: false,
      queueList: [],
      convertingElems: [],
      customHeader: ''
    }
  },
  props: {
    visible: Boolean,
    type: String,
    userId: String,
    closeDialog: Function
  },
  components: {
    DragDialog
  },
  watch: {
    visible: function (newVal) {
      if (newVal) {
        this.initQueueList()
      } else {
        this.queueList = []
        this.clearTimer()
      }
    }
  },
  mounted() {
    setTimeout(() => {
      const currentBody = this.$refs.table?.bodyWrapper
      currentBody &&
        currentBody.addEventListener('scroll', ev => {
          const scrollTop = ev.target.scrollTop
          this.customHeader = scrollTop > 10 ? 'darkHeader' : ''
        })
    }, 500)
  },
  methods: {
    initQueueList() {
      this.tableLoading = true
      if (this.type === 'PublicElem') {
        publicElemQueueService().then(response => {
          if (response.isSuccess) {
            let queueList = response.data
            if (queueList.length) {
              this.queueList = this.resortQueueList(queueList)
              this.queryConvertProgress()
            }

            this.tableLoading = false
          }
        })
      } else {
        let params = this.userId ? { userId: this.userId } : {}

        let userInfo = Store.userInfo
        let roleCode = userInfo.roleCode
        if (roleCode === 'SuperAdmin') {
          params.userId = undefined
        }
        privateElemQueueService(params).then(response => {
          if (response.isSuccess) {
            let queueList = response.data
            if (queueList.length) {
              this.queueList = this.resortQueueList(queueList)
              this.queryConvertProgress()
            }

            this.tableLoading = false
          }
        })
      }
    },
    clearTimer() {
      this.timer && clearInterval(this.timer)
      this.timer = null
    },
    queryConvertProgress() {
      this.updateConvertProgress()
      if (!this.timer) {
        this.timer = setInterval(() => {
          this.updateConvertProgress()
        }, 5000)
      }
    },
    refreshQueueList() {
      this.queueList = []
      this.tableLoading = true
      if (this.type === 'PublicElem') {
        publicElemQueueService().then(response => {
          if (response.isSuccess) {
            let queueList = response.data
            this.queueList = this.resortQueueList(queueList)
            if (!queueList.length) {
              this.timer && clearInterval(this.timer)
            }

            this.tableLoading = false
          }
        })
      } else {
        let params = this.userId ? { userId: this.userId } : {}
        privateElemQueueService(params).then(response => {
          if (response.isSuccess) {
            let queueList = response.data
            this.queueList = this.resortQueueList(queueList)
            if (!queueList.length) {
              this.timer && clearInterval(this.timer)
            }

            this.tableLoading = false
          }
        })
      }
    },
    updateConvertProgress() {
      let queueList = this.queueList.filter(el => el.owned)
      let dataSetIds = queueList.map(el => el.dataSetId)
      getElemsConvertingProgress({ dataSetIds }).then(response => {
        if (response.isSuccess) {
          let dataList = response.data
          for (let i = 0; i < dataList.length; i++) {
            let item = dataList[i]
            if (item.ratio === -1) {
              this.refreshQueueList()
              break
            }

            let ratio = Math.round(item.ratio / 100) / 100
            let find = this.queueList.find(
              el => el.dataSetId === item.dataSetId
            )

            // 用于处理转换服务停止之后再重启的情况
            let findElem = this.convertingElems.find(
              el => el.dataSetId === item.dataSetId
            )
            if (findElem && findElem.isMarked && ratio === 0) {
              this.convertingElems = []
              this.refreshQueueList()
              break
            }

            if (ratio !== 0 && find.convertStatus !== 2) {
              this.refreshQueueList()
              break
            }
            if (ratio === 100) {
              getElemConvertStatus({ dataSetId: item.dataSetId }).then(res => {
                if (res.isSuccess) {
                  let result = res.data
                  let status = result.status
                  if (status === 10) {
                    this.refreshQueueList()
                  } else {
                    this.$set(find, 'ratio', 99)
                  }
                }
              })
              break
            } else {
              this.$set(find, 'ratio', ratio)
              this.$set(find, 'rateMsg', item.message)
              if (ratio > 0) {
                if (!findElem) {
                  this.convertingElems.push({
                    dataSetId: item.dataSetId,
                    isMarked: true
                  })
                }
              }
            }
          }
        }
      })
    },
    moveQueue(datasetInfo, moveDirection) {
      let params = {
        dataSetId: datasetInfo.dataSetId,
        moveDirection
      }
      if (this.type === 'PublicElem') {
        moveClPublicConvertQueue(params).then(response => {
          if (response.isSuccess) {
            this.$message.success('移动成功')
            this.refreshQueueList()
          } else {
            this.$message.error(response.errMsg)
          }
        })
      } else {
        moveClPrivateConvertQueue(params).then(response => {
          if (response.isSuccess) {
            this.$message.success('移动成功')
            this.refreshQueueList()
          } else {
            this.$message.error(response.errMsg)
          }
        })
      }
    },
    resortQueueList(queueList) {
      let waiting = []
      let converting = []
      let isOwnedProjExist = queueList.some(el => el.owned)
      if (!isOwnedProjExist) {
        queueList = queueList.filter(el => el.owned)
      }

      queueList.forEach(item => {
        if (item.convertStatus === 2) {
          converting.push(item)
        } else {
          waiting.push(item)
        }
        converting.sort((obj1, obj2) => obj1.queueIndex - obj2.queueIndex)
        waiting.sort((obj1, obj2) => obj1.queueIndex - obj2.queueIndex)
      })
      return [...converting, ...waiting]
    },
    formatFileSize
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';
.common-table-box {
  height: 500px;
  margin-bottom: 10px;

  .common-progress-box {
    display: flex;
    .el-progress {
      width: 80%;
    }

    .custom-text {
      width: 60px;
      line-height: 12px;
      font-size: 12px;
      text-align: center;

      .text {
        color: var(--success-status-color);
      }

      .progress-name-box {
        position: absolute;
        top: 5px;
        left: 0px;
        width: calc(100% - 50px);
        color: var(--success-status-color);
      }
    }
  }
}
</style>
